import * as React from 'react';

import Feed16 from './Feed16';

export const feed16 = () => <Feed16 />;

export default {
    title: 'Icon|Fill|Feed16',
    component: Feed16,
    parameters: {
        notes: "`import Feed16 from 'box-ui-elements/es/icon/fill/Feed16';`",
    },
};
